<script>
	import LvBaseColumn from "../../table/lv-base-column";
	import {ColumnMixin} from "../mixins";

	export default {
		name: "link-table-column-operate",
		mixins: [ColumnMixin],
		components: {LvBaseColumn},
		props: {
			order: {default: -9999},
			title: {default: '操作'},
			align: {default: 'center'},
			fixed: {default: 'right'},
			buttons: {type: [Function, Array], default: null},
			maxButtons: {type: [Number, String], default: 4},
			search: {default: false},
			sort: {default: false,},
		},
		data() {
			return {}
		},
		render() {
			return (
				<lv-base-column ref="column" {...{
					props: {
						...this.columnBinding,
						scopeSlotFunc: this.cellRenderFunc,
					},
					scopedSlots: {default: this.cellRenderFunc},
				}}/>
			)
		},
		methods: {
			cellRenderFunc(data) {
				let content = null;
				let dropdownButtons = [];

				if (!!this.$scopedSlots.default) {
					content = this.$scopedSlots.default(data)
				}
				if (!!this.buttons) {

					const max = this.maxButtons - 0

					let buttons;
					if (this.$lv.$utils.typeOf(this.buttons) === 'function') {
						buttons = this.buttons(data)
					} else if (this.$lv.$utils.typeOf(this.buttons) === 'array') {
						buttons = this.buttons
					} else {
						console.error('link-table-column-operate: the type of buttons should be array or function')
						return null
					}
					if (!buttons) return null

					buttons = [...buttons].filter(item => !!item)

					for (let i = 0; i < buttons.length; i++) {
						const btn = buttons[i];
						if (btn.dropdown) {
							dropdownButtons.push(btn)
							buttons.splice(i, 1)
							i--
						}
					}

					if (dropdownButtons.length > 0) {
						if (buttons.length >= max) {
							dropdownButtons.push(...buttons.splice(max - 1, buttons.length - 1))
						}
					} else {
						if (buttons.length > max) {
							dropdownButtons.push(...buttons.splice(max - 1, buttons.length - 1))
						}
					}

					content = buttons.map(btn => (
						<link-button label={btn.label}
									 disabled={() => this.$lv.$utils.typeOf(btn.disabled) === 'function' ? btn.disabled(data) : btn.disabled}
									 onClick={e => !!btn.onClick && btn.onClick(data, e)}/>
					))
				}

				return (
					<div class="table-button lv-table-cell-normal" ondblclick={e => e.stopPropagation()}>
						{content}
						{
							(dropdownButtons.length > 0) && (
								<link-dropdown type="button"
											   buttonProps={{type: 'none'}}
											   height={null}
											   style="width:auto !important;"
											   class="link-button"
											   align="end">
									<span slot="reference">更多</span>
									<div slot="popover">
										{dropdownButtons.map(btn => <link-dropdown-item
											label={btn.label}
											disabled={() => this.$lv.$utils.typeOf(btn.disabled) === 'function' ? btn.disabled(data) : btn.disabled}
											onClick={e => !!btn.onClick && btn.onClick(data, e)}
										/>)}
									</div>
								</link-dropdown>
							)
						}
					</div>
				)
			},
		},
	}
</script>

<style lang="scss">
</style>